//NEW: UI_REVAMP
import { Image } from '@chakra-ui/react';

const ImgComp = ({ svgName, onClick, zIndex, width, height, ...props }) => {
	const svgPath = `/assets/svg/${svgName}.svg`;

	const altText = svgName ? svgName.replace(/-/g, ' ') : 'img';

	return (
		<Image
			src={svgPath}
			alt={altText}
			width={width}
			height={height}
			pointerEvents='none'
			zIndex={zIndex}
			onClick={onClick}
			userSelect='none'
			{...props}
		/>
	);
};

export default ImgComp;
